<template>
  <el-dialog title="" :visible.sync="visible" :close-on-click-modal="false" width="50%" append-to-body>
    <div>
      <p>
        请点击勾选O，选择你要使用的项目报告类型：<peixun
          type="10"
          style="display:inline-block;margin-left:5px;position:relative;top:3px;"
        ></peixun>
      </p>
      <div class="flex-row">
        <div class="col-1 pd10" @click="reportType = 'mapping'">
          <el-radio v-model="reportType" label="mapping">人选mapping报告</el-radio>
          <p class="ft-gray">自行选择需要的人选字段，并形成报告。</p>
          <div><img src="../../../assets/images/project_mapping.png" class="img_max" /></div>
        </div>
        <div class="col-1 pd10" @click="reportType = 'report'">
          <el-radio v-model="reportType" label="report">搜索进度报告</el-radio>
          <p class="ft-gray">根据项目推进情况，自动进行统计，形成进度报告。</p>
          <div><img src="../../../assets/images/project_report.png" class="img_max" /></div>
        </div>
      </div>
      <div class="text_right"><a class="btn_default" target="_blank" @click="generateReport">生成报告</a></div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      reportType: 'mapping',
      visible: false,
      pid: null,
    }
  },
  methods: {
    async getReport() {
      const { pid } = this
      if (this.reportType === 'report') {
        const loading = this.$loading({
          lock: true,
          text: '正在获取项目进展报告，请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        try {
          const res = await app.service('project').getProjectReport({
            pid: pid,
          })
          if (res && res.status === 'success' && res.data) {
            app.root.$refs.ProjectReportEditor.open({
              url: res.data.url,
              md5: res.data.md5,
              documentType: res.data && res.data.documentType,
              fileType: res.data && res.data.fileType,
              originalname: res.data && res.data.originalname,
            })
          } else this.$message.error(res.msg)
        } catch (e) {
          console.error(e)
          this.$message.error(`生成项目搜索进度报告出错`)
        }
        loading.close()
      } else {
        app.root.$refs.MappingReportChooseHeaderDialog.open(pid)
      }
    },
    openTrainingVideo() {
      app.root.$refs.TrainingVideoDialog.open('mapping')
    },
    show(pid) {
      console.log('show')
      this.pid = pid
      this.visible = true
    },
    generateReport() {
      this.visible = false
      if (this.reportType === 'mapping') {
        this.$emit('exportProjectMappingReport')
      } else {
        this.getReport()
      }
    },
  },
}
</script>
